import { createContext, FC, PropsWithChildren } from 'react'
import { AmplifyAuth } from './use-amplify'
import { apiService } from 'services/ApiService'

export const AuthContextTsp = createContext<AmplifyAuth | null>(null)

export const AuthProviderTsp: FC<IAuthProviderTsp> = ({
  children,
  amplify,
}) => {
  apiService.setAmplify(amplify)

  return (
    <AuthContextTsp.Provider value={amplify}>
      {children}
    </AuthContextTsp.Provider>
  )
}

export interface IAuthProviderTsp extends PropsWithChildren {
  amplify: AmplifyAuth | null
}
